import { __assign } from 'tslib';
import * as React from 'react';

var SmallBubbleShape = function (props) {
    return (React.createElement("svg", __assign({ height: "100%", id: "smallBubbleShape", width: "100%", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M41.466 25.772c4.764 38.73-23.68 34.3-32.087 24.296C-.544 38.26-2.893 26.944 3.774 14.052c6.725-13.005 32.768-28.313 37.692 11.72z", fill: "#000", fillRule: "evenodd", opacity: 0.44 })));
};

export { SmallBubbleShape as default };
//# sourceMappingURL=SmallBubbleShape.esm.js.map
